export const OAuth2Scopes = [
    "root"
];
// This may eventually be moved to the database
export const clients = {
    app: {
        id: "app",
        accessTokenLifetime: 60 * 60 * 24 * 365,
        grants: [
            "authorization_code",
            "refresh_token"
        ],
        redirectUris: [
            "https://example.com"
        ]
    },
    editor: {
        id: "editor",
        accessTokenLifetime: 60 * 60 * 24 * 7,
        grants: [
            "authorization_code",
            "refresh_token"
        ],
        redirectUris: [
            "https://example.com"
        ]
    }
};
// Means we'll automatically authorize the editor
export const clientAutoAuthorizeMap = {
    editor: true,
    app: true
};
export const clientSecretMap = {
    // It's ok if this is public b/c the editor will expose it anyways.
    editor: "d024bd63ce74c7ea9182aa988cc59675",
    app: "e520d66844922d55f066d86ae6e29992e"
};
